function initJobAlert() {
	document.querySelectorAll(".job_alert-layout").forEach((layout) => {
		const dialog = layout.querySelector(".job-alert-dialog");
		if (!dialog || dialog.dataset.jobAlertInit) return;
		dialog.dataset.jobAlertInit = "true";

		layout.querySelectorAll("[data-job-alert-open]").forEach((button) => {
			button.addEventListener("click", () => dialog.showModal());
		});
		dialog.querySelector("[data-job-alert-close]")?.addEventListener("click", () => dialog.close());
		dialog.addEventListener("click", (event) => event.target === dialog && dialog.close());
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initJobAlert);
} else {
	initJobAlert();
}
